import script from "./AppGroupDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AppGroupDetail.vue?vue&type=script&setup=true&lang=js"

import "./AppGroupDetail.vue?vue&type=style&index=0&id=3b082ff6&lang=css"

const __exports__ = script;

export default __exports__